export const sanitizeNameSearchInput = (value) => {
  if (!value) return '';

  return String(value)
    .replace(/[\r\n\t]/g, ' ')
    .replace(/\s+/g, ' ')
    .trimStart()
    .slice(0, 100);
};

/** Case-insensitive substring match against person name and/or employee_code (and optionally person_id). */
export const personOptionMatchesQuery = (option, rawQuery, { includePersonId = false } = {}) => {
  if (!option || typeof option === 'string') return false;
  const query = String(rawQuery || '').trim().toLowerCase();
  if (!query) return true;
  const name = String(option.name || '').toLowerCase();
  const code = String(option.employee_code || '').toLowerCase();
  if (name.includes(query) || code.includes(query)) return true;
  if (includePersonId) {
    const personId = String(option.person_id || '').toLowerCase();
    if (personId.includes(query)) return true;
  }
  return false;
};

/** MUI Autocomplete filterOptions: match name or employee_code. */
export const filterPersonNameOptions = (options, state, { includePersonId = false } = {}) => {
  const list = Array.isArray(options) ? options : [];
  const query = state?.inputValue || '';
  if (!String(query).trim()) return list;
  return list.filter((option) => personOptionMatchesQuery(option, query, { includePersonId: option?.person_id != undefined }));
};

/**
 * Resolve typed freeSolo text to a person option by exact employee_code (preferred)
 * or exact name (case-insensitive). Returns null when no unique match.
 */
export const resolvePersonOptionBySearchText = (options, rawText) => {
  const text = String(rawText || '').trim().toLowerCase();
  if (!text || !Array.isArray(options) || options.length === 0) return null;

  const byCode = options.filter(
    (opt) => opt && typeof opt === 'object' && String(opt.employee_code || '').trim().toLowerCase() === text
  );
  if (byCode.length === 1) return byCode[0];
  if (byCode.length > 1) return byCode[0];

  const byName = options.filter(
    (opt) => opt && typeof opt === 'object' && String(opt.name || '').trim().toLowerCase() === text
  );
  if (byName.length >= 1) return byName[0];

  return null;
};

/** Display label: name, optionally with employee code. */
export const formatPersonNameOptionLabel = (option, { includeCode = false } = {}) => {
  if (!option) return '';
  if (typeof option === 'string') return option;
  const namePart = String(option.name || '').trim();
  if (!includeCode) return namePart;
  const personId = String(option.person_id || '').trim();
  return personId ? `${namePart} (${personId})` : namePart;
};
